var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('h2',[_vm._v(_vm._s(_vm.book.title))]),_c('p',[_vm._v(_vm._s(_vm.book.author))]),_vm._l((_vm.quotes),function(quote){return _c('QuoteItem',{key:quote.id,attrs:{"quote":quote}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }